<app-success-banner [bannerData]="bannerData$ | async"></app-success-banner>
<app-temporary-info-message></app-temporary-info-message>
<router-outlet></router-outlet>

<!-- Selector flotante de temas -->
<app-floating-theme-selector></app-floating-theme-selector>
